export default __webpack_public_path__ + "static/media/formatOnePlayUnselected.f5c603f4.svg";